<template>
<div class="menu-overlay" :style="hovered ? 'background: rgba(0,0,0,0.8);' : ''">

  <transition-group tag="div" name="slide-in" :style="{ '--total': length + 1 }">
    <img v-for="l,i in sources" :key="i + destination" :src="l" :style="{'--i': i}" v-show="hovered">
  </transition-group>
</div>
</template>

<script>
export default {
  data() {
    return {
      sources: [
        // require('@/assets/images/menu/1.png'),
        // require('@/assets/images/menu/2.png'),
        // require('@/assets/images/menu/3.png'),
        // require('@/assets/images/menu/4.png'),
        // require('@/assets/images/menu/5.png'),
        // require('@/assets/images/menu/6.png'),
      ],
    }
  },
  mounted() {
    this.srcs()
    // var images = ['home', 'journey', 'shop', 'meditation', 'credits'];
    // var length = [5, 6, 6, 5, 4]
    // var sources = []
    // for (var i = 0; i < images.length; i++) {
    //   for (var j = 0; j < length[i]; j++) {
    //     let temp = '/menu/' + images[i] + '/' + (j + 1) + '.png'
    //     sources.push("<link rel='prefetch' href='" + temp + "' as='image'>")
    //     // sources.push(temp)
    //     // console.log();
    //
    //   }
    //
    // }
    // console.log(sources.join(""));
    // // this.preloadImages(sources)
  },
  watch: {
    hovered() {
      this.sources = []
      this.srcs();
    }
  },
  methods: {
    // preloadImages(srcs, imgs) {
    //   var img;
    //   var self = this;
    //   var remaining = srcs.length;
    //   for (var i = 0; i < srcs.length; i++) {
    //     img = new Image();
    //     img.onload = function() {
    //       --remaining;
    //       if (remaining <= 0) {
    //         // callback();
    //         self.preloaded = true;
    //       }
    //     };
    //     img.src = srcs[i];
    //     //  imgs.push(img);
    //   }
    // },
    srcs() {
      if (this.length == 0 || this.destination == '') {
        return
      }
      for (var i = 0; i < this.length; i++) {
        let temp = '/menu/' + this.destination + '/' + (i + 1) + '.png'
        this.sources.push(temp)
        // let temp = require('@/assets/images/menu/' + this.destination + '/' + (i + 1) + '.png')
        // this.sources.push(temp)
      }
    }
  },
  props: {
    hovered: {
      type: Boolean,
      default: false
    },
    destination: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 0
    },
  }
}
</script>

<style lang="scss">
.menu-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    bottom: 0;
    background: transparent;
    transition: background 0.5s ease;
    pointer-events: none;
    img {
        position: absolute;
        bottom: 0;
        max-height: 200vh;
        // transform: translateY(-20px);
        transition-delay: calc(0.075s * var(--i)) !important;
        animation: upDownShop 3s alternate infinite ease-in-out;
        will-change: transform, opacity, filter;
        animation-delay: calc(1s * var(--i)) !important;

    }

}
.slide-in {

    &-move {
        transition: opacity 0.15s linear !important;
        // transition: opacity 0.15s linear, transform 0.5s ease-in-out !important;
    }

    &-leave-active {
        transition: opacity 0.15s linear, filter 0.5s cubic-bezier(.2,.5,.1,1) !important; //cubic-bezier(.7,0,.7,1);
        // transition: opacity 0.15s linear, transform 0.5s cubic-bezier(.5,0,.7,.4), filter 0.5s cubic-bezier(.2,.5,.1,1) !important; //cubic-bezier(.7,0,.7,1);
        // transition-delay: calc(0.1s * (var(--total) - var(--i))) !important;
    }

    &-enter-active {
        transition: opacity 0.15s linear, filter 0.5s cubic-bezier(.2,.5,.1,1) !important;
        // transition: opacity 0.15s linear, transform 0.5s cubic-bezier(.2,.5,.1,1), filter 0.5s cubic-bezier(.2,.5,.1,1) !important;
    }

    &-enter,
    &-leave-to {
        opacity: 0;
        filter: blur(5px);
    }

    &-enter {
        //  transform: translateY(-1em) !important;
    }
    &-leave-to {
        //  transform: translateY(1em) !important;
    }

}
</style>
